export * from './lib/shared-tools-device.module';
export * from './lib/device.service';
